namespace TotalContest {
    import Component = TotalCore.Common.Component;

    @Component('components.totalcontest', {
        templateUrl: 'progressive-textarea-template',
        bindings: {
            model: '=ngModel',
            rows: '@',
            uid: '@',
        }
    })
    class ProgressiveTextareaComponent {
        public mode = 'simple';

        constructor() {

        }

        isAdvanced() {
            return this.mode === 'advanced';
        }

        isSimple() {
            return this.mode === 'simple';
        }

        switchToAdvanced() {
            this.mode = 'advanced';
        }

        switchToSimple() {
            this.mode = 'simple';
        }
    }
}
